export const THIRTY_SECONDS = 30000;